/**
 * Created by andrey on 12.08.2025
 */

const ConversionsMetricsLogger = function () {
    this.config = {
        lifetime: "180 days"
    };

    this.metrics = true;
};

ConversionsMetricsLogger.prototype.trackEvent = function (name, params = {}) {
    connector.metrics.logEvent(name, {
        value: params.value || 1,
        event: connector._metrics.registered,
        channel: connector._metrics.channel || "",
        channelMetrics: true
    });
};
